<template>
<div class="row justify-content-md-center">

	<div class="col-12 col-xl-8">
		<b-form @submit="submitForm"
		        class="mb-3">
			<b-btn variant="outline-secondary"
			       v-b-tooltip.hover
			       title="Terug"
			       class="pull-right"
			       exact
			       :to="{ name: 'categoryList' }">
				<i class="fa fa-fw fa-reply"></i>
			</b-btn>
			<h1 class="display-4"
			    v-if="mode == 'edit'">Categorie aanpassen</h1>
			<h1 class="display-4"
			    v-if="mode == 'add'">Categorie toevoegen</h1>
			<h2 v-if="!isFetching">{{ form.title }}</h2>

			<partial-loader :loading="isFetching"></partial-loader>

			<div v-if="!isFetching">

				<b-alert v-if="formError"
				         show
				         variant="warning">
					<span v-for="errors in formError.errors">
							<span v-for="error in errors">{{ error }}<br /></span>
					</span>
				</b-alert>

				<div class="row">
					<div class="col-4">
						<b-form-group label="Titel:">
							<b-form-input type="text"
										  autocomplete="off"
							              v-model="slugTitle">
							</b-form-input>
						</b-form-group>

						<b-form-group label="Afkorting:">
							<b-form-input type="text"
										  autocomplete="off"
							              v-model="form.abbreviation">
							</b-form-input>
						</b-form-group>

						<b-form-group label="Code:">
							<b-form-input type="text"
										  autocomplete="off"
							              v-model="form.slug">
							</b-form-input>
						</b-form-group>

						<b-form-group :label="$t('category.startTime')">
							<datetime
								type="datetime"
								v-model="form.auction_date"
								input-class="form-control"
								value-zone="local"
							></datetime>
						</b-form-group>

						<b-form-group :label="$t('category.startAuctionOrderNumber')">
							<b-form-input type="number"
							              min="0"
										  autocomplete="off"
							              v-model="form.start_auction_order_number">
							</b-form-input>
						</b-form-group>

						<b-form-checkbox v-model="form.hidden"
											value="1"
											unchecked-value="0">
							{{ $t('category.hiddenCategory') }}
						</b-form-checkbox>
					</div>

					<div class="col">
						<b-form-group label="Beschrijving:">
							<b-form-textarea v-model="form.description"
							                 :rows="7">
							</b-form-textarea>
						</b-form-group>
					</div>
				</div>

				<b-btn v-if="mode == 'edit'"
				       type="submit"
				       variant="primary"
				       v-b-tooltip.hover
				       title="Opslaan"
				       class="pull-right"><i class="fa fa-fw fa-save"></i></b-btn>

				<b-btn v-if="mode == 'add'"
				       type="submit"
				       variant="primary"
				       v-b-tooltip.hover
				       title="Categorie aanmaken"
				       class="pull-right"><i class="fa fa-fw fa-save"></i></b-btn>
			</div>

		</b-form>

	</div>

</div>
</template>

<style>
.vdatetime-calendar__month__day--selected > span > span, .vdatetime-calendar__month__day--selected:hover > span > span, .vdatetime-popup__header {
	background: #4C96E6 !important;
}
.vdatetime-popup__actions__button, .vdatetime-time-picker__item--selected, .vdatetime-year-picker__item--selected {
	color: #4C96E6 !important;
}
</style>


<script>
import { isNil, pick, forOwn } from 'lodash';
import CategoryService from '@/services/category-service';
import PartialLoader from '@/components/elements/PartialLoader';
import { replaceEmptyByNull } from '@/helpers/object-helper';
import { flashSuccess } from '@/helpers/flash-message-helper';
import { DateTime } from 'luxon';

export default {
	components: {
		PartialLoader
	},
	data() {
		return {
			isFetching: true,
			mode: 'add',
			category: {},
			form: {
				title: '',
				slug: '',
				description: '',
				abbreviation: '',
				start_auction_order_number: '',
				hidden: false,
				auction_date: null,
			},
			formError: false,
			slugTitle: '',
		}
	},
	watch: {
		category() {
			this.form = pick(this.category, [
				'title',
				'abbreviation',
				'slug',
				'description',
				'start_auction_order_number',
				'hidden',
			]);

			if(this.category.auction_date !== null) {
				let dateString = this.category.auction_date.replace(/-/g, '/');
				let dateObj = new Date(dateString);
				this.form.auction_date = dateObj.toISOString();
			}

			this.slugTitle = this.form.title;
		},
		slugTitle() {
			this.form.title = this.slugTitle;
			this.form.slug = this.slugTitle.replace(/\W+/g, '-').toLowerCase();
		}
	},
	methods: {
		fetchCategory(categoryId) {
			return CategoryService.getOne(categoryId)
				.then(response => {
					this.isFetching = false;
					this.category = response;
				}).catch(error => {
					this.isFetching = false;
					this.error = error.message;
				});
		},
		submitForm(event) {
			this.isFetching = true;
			event.preventDefault();

			const post = replaceEmptyByNull(this.form);

			if (this.mode == 'add') {
				return CategoryService.create(post).then(response => {
					flashSuccess(this.$t('category.createSuccess'), true);
					this.$router.push({ name: 'categoryList' });
				}).catch(error => {
					this.isFetching = false;
					this.formError = error.response.data
				});
			} else {
				return CategoryService.update(this.$route.params.categoryId, post).then(response => {
					flashSuccess(this.$t('category.updateSuccess'), true);
					this.$router.push({ name: 'categoryList' });
				}).catch(error => {
					this.isFetching = false;
					this.formError = error.response.data;
				});
			}

		}
	},
	mounted() {
		// check if item id exists otherwise add :)
		if (!isNil(this.$route.params.categoryId)) {
			this.mode = 'edit';
			this.fetchCategory(this.$route.params.categoryId);
		} else {
			this.isFetching = false;
		}
	}
}
</script>



// WEBPACK FOOTER //
// CategoryForm.vue?0863f379